module.exports = __webpack_public_path__ + "media/BrightOn.83d3574d.wav";